import firebase from '../Firebase/Firebase';
const call = (name) => firebase.app().functions('europe-west1').httpsCallable(name);
export const getInvoicingDashboard = async () => (await call('getInvoicingDashboard')({})).data;
export const saveInvoicingProfile = async (profile) => (await call('saveInvoicingProfile')({ profile })).data;
export const startSuperPdpOnboarding = async () => (await call('startSuperPdpOnboarding')({})).data;
export const refreshSuperPdpStatus = async () => (await call('refreshSuperPdpStatus')({})).data;
export const createOfficialInvoiceDraft = async (demandId) => (await call('createOfficialInvoiceDraft')({ demandId })).data;
export const issueOfficialInvoice = async (demandId) => (await call('issueOfficialInvoice')({ demandId })).data;
export const reportInvoicePayment = async (demandId, paidAt) => (await call('reportInvoicePayment')({ demandId, paidAt })).data;

export const getProjectInvoice = async (demandId) => (await call('getProjectInvoice')({ demandId })).data;
